import { render, staticRenderFns } from "./ExpenseTypeAdd.vue?vue&type=template&id=02e079a4&scoped=true&"
import script from "./ExpenseTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ExpenseTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e079a4",
  null
  
)

export default component.exports